import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCarinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				fill: "currentColor",
				cx: 6,
				cy: 14,
				r: 1
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "currentColor",
				cx: 18,
				cy: 14,
				r: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 10c.52-1.232.996-2.336 1.427-3.31C6.397 4.498 6.617 4 8.757 4h6.661c2.141 0 2.361.498 3.33 2.69.431.974.849 2.078 1.252 3.31",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 18v2m12-2v2M4 10h16a2 2 0 0 1 2 2v6H2v-6a2 2 0 0 1 2-2z",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgCarinline;
